import { request } from '@/api/index';
export function getList(data) {
  return request({
    url: '/api/TenantUser/GetUsers',
    method: 'get',
    params: data
  });
}
export function deleteTenantUser(params) {
  return request({
    url: '/api/TenantUser/DeleteTenantUser',
    method: 'post',
    params: params
  });
}
export function authorize(params) {
  return request({
    url: '/api/TenantUser/Authorize',
    method: 'post',
    params: params
  });
}
export function forbidden(params) {
  return request({
    url: '/api/TenantUser/Forbidden',
    method: 'post',
    params: params
  });
}
export function addTenantUser(params) {
  return request({
    url: '/api/TenantUser/AddTenantUser',
    method: 'post',
    params: params
  });
}
export function editTenantUser(params) {
  return request({
    url: '/api/TenantUser/EditUserInfo',
    method: 'post',
    params: params
  });
}